import React, { useMemo } from 'react';
import { LaboratoryRequestItem } from '../../Interfaces/LaboratoryRequestItem.intefrace';
import NavigationStepper, {
	NavigationStepperComponentParams,
	NavigationStepperItemType,
} from '../../../../Components/Stepper/NavigationStepper';
import LaboratoryRequestCreateFormItemTab from './LaboratoryRequestCreateFormItemTab';
import { LaboratoryRequestItemType } from '../../Enums/LaboratoryRequestItemType';
import ScrollContainer from '../../../Base/Components/ScrollContainer';

interface Props {
	items?: LaboratoryRequestItem[];
	onItemSelect: (item: LaboratoryRequestItem) => void;
}

const LaboratoryRequestCreateFormItemTabContainer: React.FC<Props> = ({
	items,
	onItemSelect,
}) => {
	const steps: NavigationStepperItemType[] = useMemo(() => {
		const tempSteps: NavigationStepperItemType[] = [];
		items?.forEach(item => {
			if (item.type === LaboratoryRequestItemType.TAB) {
				tempSteps.push({
					key: item.key,
					name: item.title,
					component: (params: NavigationStepperComponentParams) => (
						<ScrollContainer>
							<LaboratoryRequestCreateFormItemTab
								item={item}
								onItemSelect={onItemSelect}
							/>
						</ScrollContainer>
					),
				});
			}
		});
		return tempSteps;
	}, [items]);

	return (
		<NavigationStepper
			steps={steps}
			initialStepPath={steps[0]?.key}
			showStepNumbers={false}
			canSkip={true}
		/>
	);
};

export default LaboratoryRequestCreateFormItemTabContainer;
